const FromArrEditor = [
    
    {
      modelvalue: '',
      title: "产品线：",
      inputtype: "select",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "",
      placeholder: "请选择",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 50,
      marginTop: 5,
      displayVal: "inline-block",
      fontWeightVal: 500,
      options: [],
    },
   
     {
      modelValue: undefined,
      title: "一月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: -310,
      marginTop: 55,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "二月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 50,
      marginTop: 55,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "三月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 710,
      marginTop: -32,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
     {
      modelValue: undefined,
      title: "四月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 5,
      marginTop: 20,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "五月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 50,
      marginTop: 20,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "六月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 710,
      marginTop: -32,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
     {
      modelValue: undefined,
      title: "七月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 5,
      marginTop: 20,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "八月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 50,
      marginTop: 20,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "九月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 710,
      marginTop: -32,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
     {
      modelValue: undefined,
      title: "十月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 5,
      marginTop: 20,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "十一月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 35,
      marginTop: 20,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
    {
      modelValue: undefined,
      title: "十二月分摊比例：",
      inputtype: "NumberInput",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "text",
      placeholder: "请输入",
      width: 210,
      height: 32,
      disabled: false,
      marginLeft: 695,
      marginTop: -32,
      displayVal: "inline-block",
      fontWeightVal: 500,
      max: undefined,
      min: 0
    },
  ];
  export default FromArrEditor;
  